import { observer } from 'mobx-react';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import CachedIcon from '@mui/icons-material/Cached';
import { Box } from '@mui/material';
import { IconButton } from 'components/IconButton';

import ScormWrapper from '@common/components/ScormWrapper';
import { IScormModel } from '@common/models/Chunks/Scorm';
import { IGradeBookModel } from '@common/models/GradeBooks/GradeBook';

type ScormPlayerProps = {
	scorm: IScormModel;
	gradeBook: IGradeBookModel;
	isReloadButton?: boolean;
	isReloadButtonWithNoData?: boolean;
};

function ScormPlayer({
	scorm,
	gradeBook,
	isReloadButton = false,
	isReloadButtonWithNoData = false,
}: ScormPlayerProps) {
	const [isShowReloadButton, setIsShowReloadButton] = useState(isReloadButton);
	const { t } = useTranslation();
	const orientationHint = t('scorm.rotateHint');

	const handleCommit = (data: any) => {
		console.log('handle commit data ------->', data);
		scorm.save(data, gradeBook.id);
	};

	return (
		<Box position="relative">
			<ScormWrapper
				scorm={scorm}
				modified={scorm.modified}
				onCommit={handleCommit}
				fetchData={() => scorm.fetchUserData()}
				enableOrientationLock
				orientationHint={orientationHint}
				showReloadButton={(data) => {
					if (isReloadButtonWithNoData) {
						setIsShowReloadButton(data);
					}
				}}
			/>

			{isShowReloadButton && (
				<IconButton size="large" onClick={() => scorm.modify()}>
					<CachedIcon />
				</IconButton>
			)}
		</Box>
	);
}

export default observer(ScormPlayer);
